import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { CurrencyUtil, I8N, LocaleUtil } from "@eres/core";
import { Receipt } from "../../../../apis/privatesell/enitites";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { openDocument } from "@my-dld/utils/Utils";

interface Props {
	receipts: Receipt[];
}

export default class ReceiptDetails extends Component<Props> {
	componentDidMount() {
		this.configDataTable();
	}

	render() {
		const receipts = this.props.receipts;
		return <ListDataView
			title={ Strings.payment_receipts }
			id={ "receiptTable" }
			items={ receipts }
			renderListHeader={ () => <RenderHeader/> }
			renderListItem={ ( item: Receipt, index ) => {
				return <RenderListItem
					key={ "invoice_" + index }
					receipt={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#receiptTable" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onDetails = this.onDetails;
			window.$( "#receiptTable" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	private onDetails = ( item: Receipt ) => {
		const statementUrl = item.path.replace( /\\/g, "/" );
		openDocument( statementUrl, Strings.receipts + item.id );
	};
}


function RenderHeader() {
	return <tr>
		<th>{ Strings.invoice_type }</th>
		<th>{ Strings.reference_number }</th>
		<th>{ Strings.amount }</th>
		<th>{ Strings.action }</th>
	</tr>;
}

function RenderListItem( props: { receipt: Receipt } ) {
	const { receipt } = props;
	return <tr>
		<td data-label={ Strings.invoice_type }>{ LocaleUtil.getLocalValue( receipt.invoiceType ) }</td>
		<td data-label={ Strings.reference_number }>{ receipt.receiptNumber }</td>
		<td data-label={ Strings.amount }>{ CurrencyUtil.toFormattedCurrency( Number( receipt.amount ) ) + " " + Strings.aed }</td>
		<td>
			<a
				data-item={ JSON.stringify( receipt ) }
				className="btn-link">{ Strings.download }</a>
		</td>
	</tr>;
}
